module.exports = __webpack_public_path__ + "img/work_from_office2.c2ba1d7e.png";